import { City, State } from "country-state-city";
import React, { useEffect, useState } from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

const AddressForm = ({ validation, fieldPath = "primaryBranch" }) => {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const getValue = (field) =>
    validation?.values?.[fieldPath]?.[field] || "";

  const getError = (field) =>
    validation?.touched?.[fieldPath]?.[field] &&
    validation?.errors?.[fieldPath]?.[field];

  useEffect(() => {
    setStates(State.getStatesOfCountry("IN"));
  }, []);

  useEffect(() => {
    const selectedState = states.find((s) => s.name === getValue("state"));
    if (selectedState) {
      setCities(City.getCitiesOfState("IN", selectedState.isoCode));
    } else {
      setCities([]);
    }
  }, [getValue("state"), states]);

  return (
    <>
      <FormGroup>
        <Label>Address Line 1</Label>
        <Input
          type="text"
          name={`${fieldPath}.addressLine1`}
          placeholder="Enter Address Line 1"
          value={getValue("addressLine1")}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          invalid={getError("addressLine1")}
        />
        {getError("addressLine1") && (
          <p style={{ color: "red" }}>
            {validation.errors[fieldPath].addressLine1}
          </p>
        )}
      </FormGroup>

      <FormGroup>
        <Label>Address Line 2</Label>
        <Input
          type="text"
          name={`${fieldPath}.addressLine2`}
          placeholder="Enter Address Line 2"
          value={getValue("addressLine2")}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
        />
      </FormGroup>

      <Row>
        <Col>
      <FormGroup>
        <Label>State</Label>
        <Input
          type="select"
          name={`${fieldPath}.state`}
          value={getValue("state")}
          onChange={(e) => {
            validation.handleChange(e);
            validation.setFieldValue(`${fieldPath}.city`, "");
          }}
          onBlur={validation.handleBlur}
          invalid={!!getError("state")}
        >
          <option value="">Select State</option>
          {states.map((state) => (
            <option key={state.isoCode} value={state.name}>
              {state.name}
            </option>
          ))}
        </Input>
        {getError("state") && (
          <p style={{ color: "red" }}>
            {validation.errors[fieldPath].state}
          </p>
        )}
      </FormGroup>
      </Col>
      <Col>
      <FormGroup>
        <Label>City</Label>
        <Input
          type="select"
          name={`${fieldPath}.city`}
          value={getValue("city")}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          invalid={!!getError("city")}
        >
          <option value="">Select City</option>
          {cities.map((city) => (
            <option key={city.name} value={city.name}>
              {city.name}
            </option>
          ))}
        </Input>
        {getError("city") && (
          <p style={{ color: "red" }}>
            {validation.errors[fieldPath].city}
          </p>
        )}
      </FormGroup>
      </Col>
      <Col>
      <FormGroup>
        <Label>Pincode</Label>
        <Input
  type="text"
  name={`${fieldPath}.pincode`}
  placeholder="Enter Pincode"
  value={getValue("pincode")}
  inputMode="numeric"   
  pattern="[0-9]*"      
  maxLength="6"
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); 
    validation.setFieldValue(`${fieldPath}.pincode`, value);
  }}
  onBlur={validation.handleBlur}
  invalid={!!getError("pincode")}
/>
        {getError("pincode") && (
          <p style={{ color: "red" }}>
            {validation.errors[fieldPath].pincode}
          </p>
        )}
      </FormGroup>
      </Col>
      </Row>
    </>
  );
};

export default AddressForm;